/* ==================================================
 *  Fast Scroll
 * ==================================================*/

function fastScroll(classItem) {

  'use strict';

  var $target = $('body');
  var $header = $('.header');
  var headerOffset = ($header.offset().top / 2);

  $(window).on('scrollHandler', function (ev, args) {
    if ($('.' + classItem).length > 0) {
      if (window.matchMedia('(min-width: 768px)').matches) {
        if ($(window).scrollTop() > headerOffset) {
          $target.addClass(classItem + '--fast-scroll');
        } else {
          $target.removeClass(classItem + '--fast-scroll');
        }
      }
    }
  });
}
